/*
 * @Author: mqlpcthree mql_pcthree@163.com
 * @Date: 2023-10-23 09:06:01
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @LastEditTime: 2023-10-28 17:50:31
 * @FilePath: \mei_qi_zeroweb_endlyq\src\common\receiptAnnouncement.js
 * @Description: 支付播报
 */

// eslint-disable-next-line no-unused-vars
const musics = [
    new Audio(require('../assets/audio/0.mp3')),
    new Audio(require('../assets/audio/1.mp3')),
    new Audio(require('../assets/audio/2.mp3')),
    new Audio(require('../assets/audio/3.mp3')),
    new Audio(require('../assets/audio/4.mp3')),
    new Audio(require('../assets/audio/5.mp3')),
    new Audio(require('../assets/audio/6.mp3')),
    new Audio(require('../assets/audio/7.mp3')),
    new Audio(require('../assets/audio/8.mp3')),
    new Audio(require('../assets/audio/9.mp3')),
    new Audio(require('../assets/audio/10.mp3'))
]

// eslint-disable-next-line no-unused-vars
const musicsh = {
    '点': new Audio(require('../assets/audio/点.mp3')),
    '万': new Audio(require('../assets/audio/万.mp3')),
    '元': new Audio(require('../assets/audio/元.mp3')),
    '千': new Audio(require('../assets/audio/千.mp3')),
    '十': new Audio(require('../assets/audio/10.mp3')),
    '百': new Audio(require('../assets/audio/百.mp3')),
    weixin: new Audio(require('../assets/audio/微信收款.mp3')),
    zhifubao: new Audio(require('../assets/audio/支付宝收款.mp3'))
}

/**
 * 交易播报
 * @param {number} num 交易金额
 * @param {number} paytype 交易类型 1:微信 2:支付宝
 */
export default function receivingAudio(num, paytype) {
    console.log('语音播报:', num, paytype)
    console.log(JSON.parse(window.localStorage.getItem('tenant')).isOpenBroadcast)
    if (JSON.parse(window.localStorage.getItem('tenant')).isOpenBroadcast == 0) {
        return
    }

    let numArray = Array.from(convertToChinaNum(String(num)))
    // 判断收款类型
    if (paytype == 1) { numArray.splice(0, 0, 'weixin') } else { numArray.splice(0, 0, 'zhifubao') }
    numArray.push('元')
    audioPlay(numArray)
}

/**
 * 开始播报
 * @param {*} num
 * @param {*} index
 */
function audioPlay(num, index = 0) {
    if (num.length > 0) {
        // 判断内容是否是数字
        let music = ''
        if (!isNaN(num[index])) {
            music = 'musics'
        } else {
            music = 'musicsh'
        }

        // eslint-disable-next-line no-eval
        eval(music)[num[index]].onended = () => {
            if (index + 1 < num.length) {
                index++
                audioPlay(num, index)
            }
        }
        // eslint-disable-next-line no-eval
        eval(music)[num[index]].play()
    };
}

/**
 * 转换格式
 * @param {*} num
 * @returns
 */
function convertToChinaNum(num) {
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']// 可继续追加更高位转换值
    var numArray = []
    if (num.indexOf('.')) {
        numArray = num.split('.')
        num = numArray[0]
        var decimalPart = numArray[1]
    }

    if (!num || isNaN(num)) {
        return '零'
    }

    var english = num.toString().split('')
    var result = ''
    for (var i = 0; i < english.length; i++) {
        var des = english.length - 1 - i// 倒序排列设值
        result = arr2[i] + result
        var arrItem = english[des]
        result = arrItem + result
    }

    // 将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/0(千|百|十)/g, '0').replace(/十0/g, '十')
    // 合并中间多个零为一个零
    result = result.replace(/0+/g, '0')
    // 将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/0亿/g, '亿').replace(/0万/g, '万')
    // 将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿')
    // 移除末尾的零
    if (result.length > 1) result = result.replace(/0+$/, '')
    // 将【零一十】换成【零十】
    // result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
    // 将【一十】换成【十】
    result = result.replace(/^1十/g, '十')

    if (decimalPart) {
        result += '点' + decimalPart
        result = result.replace(/0+$/, '')
    }

    return result
}



// WEBPACK FOOTER //
// ./src/common/receivingAudio.js